export * from './details-view-routing.module'
export * from './details-view.component'
export * from './details-view.module'
